import React from "react";


import {
    Col
} from "react-bootstrap";


import "./index.scss";


type CardSubTitleComponentProps = {
    cardSubTitle: string;
};


export const CardSubTitleComponent:React.FC<CardSubTitleComponentProps> = ({
    cardSubTitle
}) => {

    if (!cardSubTitle) {
        return null;
    }

    return (
        <Col xs={12} className={'card-subtitle-component'}>
            <span>{cardSubTitle}</span>
        </Col>
    );

};


export default CardSubTitleComponent;
